module.exports = __webpack_public_path__ + "static/contact-9eab929fac4bd40bdb5f765e2c2ccb60.png";